import { track } from '@vercel/analytics';

/**
 * Safely send a custom event to Vercel Web Analytics.
 *
 * @param {string} name – short event identifier ( ≤ 255 chars )
 * @param {object} [data] – optional flat object ( strings | numbers | booleans | null )
 */
export function trackEvent(name, data = {}) {
  try {
    track(name, data);
  } catch (err) {
    // Fail-silent so analytics never break the user flow
    if (import.meta.env.DEV) {
      console.warn('[analyticsUtils] track() failed', err);
    }
  }
} 